import React from "react";
import "./TimeLine.css";
import { FaRegClock } from "react-icons/fa";

const TimeLine = () => {
  return (
    <div className="timeline_main">
      <div className="timeline_con">
        <div className="timeline_flex">
          <div className="timeline_first_main">
            <div className="timeline_first">
              <div className="timeline_inner_since_flex">
                <p className="timeline_since">1963</p>
                <p className="timeline_step_head">Introduced</p>
              </div>
              <div className="timeline_third timeline_third_align_end">
                <div className="timeline_third_inner">
                  {" "}
                  <p className="timeline_text">
                    Tried and Tested various business models. Stopped retailing
                    of the fancy garments and started selling readymade School
                    uniforms along with setting up in house manufacturing
                    facility
                  </p>
                </div>
              </div>
              <div className="timeline_inner_since_flex">
                <p className="timeline_since">1999</p>
                <p className="timeline_step_head">Expanded</p>
              </div>
              <div className="timeline_third_inner">
                <p className="timeline_text">
                  Expanded and opened 2nd retail showroom of 4500 Sq. ft and a
                  facility to cater 60 customers at a time. First exclusive
                  school uniform store to have second branch for school uniforms
                </p>
              </div>
              <div className="timeline_inner_since_flex">
                <p className="timeline_since">2016</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>
              <div className="timeline_third_inner">
                {" "}
                <p className="timeline_text">
                  Developed an E-commerce app for all the parents to shop online
                  and developed necessary infrastructure
                </p>
              </div>
              <div className="timeline_inner_since_flex">
                <p className="timeline_since">2022</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>
              <div className="timeline_third_inner">
                <p className="timeline_text">
                  Expanding the chain of retail outlets by adding 3rd showroom
                  in Rajkot of 6000 Sq ft having the capacity to serve 90+
                  customers at a time. Expansion of The Alchemy Drip, with entry
                  in retail business
                </p>
              </div>
            </div>
          </div>
          <div className="timeline_sec">
            <div className="timeline_icon_bg">
              <div className="timeline_icon_bg_sec">
                <FaRegClock className="timeline_icon" />
              </div>
            </div>

            <div className="timeline_icon_bg2">
              <div className="timeline_icon_bg_sec2">
                <FaRegClock className="timeline_icon2" />
              </div>
            </div>
            <div className="timeline_icon_bg3">
              <div className="timeline_icon_bg_sec3">
                <FaRegClock className="timeline_icon3" />
              </div>
            </div>
            <div className="timeline_icon_bg4">
              <div className="timeline_icon_bg_sec4">
                <FaRegClock className="timeline_icon4" />
              </div>
            </div>
            <div className="timeline_icon_bg5">
              <div className="timeline_icon_bg_sec5">
                <FaRegClock className="timeline_icon5" />
              </div>
            </div>
            <div className="timeline_icon_bg6">
              <div className="timeline_icon_bg_sec6">
                <FaRegClock className="timeline_icon6" />
              </div>
            </div>

            <div className="timeline_icon_bg7">
              <div className="timeline_icon_bg_sec7">
                <FaRegClock className="timeline_icon7" />
              </div>
            </div>

            <div className="timeline_icon_bg8">
              <div className="timeline_icon_bg_sec8">
                <FaRegClock className="timeline_icon8" />
              </div>
            </div>
          </div>
          <div className="timeline_third_main">
            <div className="timeline_third">
              <div className="timeline_third_inner">
                <p className="timeline_text">
                  Established a readymade garment store with the name 'Deepak
                  Readymade House' selling all types of fancy garments and
                  School Uniforms fabric in Rajkot, Gujarat
                </p>
              </div>
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start">
                <p className="timeline_since">1991</p>
                <p className="timeline_step_head">Expanded</p>
              </div>
              <div className="timeline_third_inner">
                <p className="timeline_text">
                  Expanded the retail store to 1800 Sq. Ft store with a capacity
                  to serve 25 customers at a time
                </p>
              </div>
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start">
                <p className="timeline_since">2009</p>
                <p className="timeline_step_head">Expanded</p>
              </div>
              <div className="timeline_third_inner">
                {" "}
                <p className="timeline_text">
                  Entered into a completely digital method for smooth store
                  management and operations
                </p>
              </div>
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start">
                <p className="timeline_since">2018</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>
              <div className="timeline_third_inner">
                <p className="timeline_text">
                  Expansion of the same business in Bangalore under the name of
                  The Alchemy Drip.
                </p>
              </div>

              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start">
                <p className="timeline_since">2023</p>
                <p className="timeline_step_head">Growth</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* responsive View */}

      <div className="timeline_main_resp">
        <div className="timeline_flex_resp">
          <div className="timeline_icon_bg_resp">
            <div className="timeline_icon_bg_sec_resp">
              <FaRegClock className="timeline_icon_resp" />
            </div>
          </div>
          <div className="timeline_flex_part1">
            <div className="timeline_icon_bg_resp2">
              <div className="timeline_icon_bg_sec_resp">
                <FaRegClock className="timeline_icon_resp" />
              </div>
            </div>

            <div className="timeline_icon_bg_resp2">
              <div className="timeline_icon_bg_sec_resp">
                <FaRegClock className="timeline_icon_resp" />
              </div>
            </div>

            <div className="timeline_icon_bg_resp3">
              <div className="timeline_icon_bg_sec_resp">
                <FaRegClock className="timeline_icon_resp" />
              </div>
            </div>

            <div className="timeline_icon_bg_resp4">
              <div className="timeline_icon_bg_sec_resp">
                <FaRegClock className="timeline_icon_resp" />
              </div>
            </div>
          </div>
          <div className="timeline_flex_part2_resp">
            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">1963</p>
                <p className="timeline_step_head">Introduced</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                {" "}
                <p className="timeline_text">
                  Established a readymade garment store with the name 'Deepak
                  Readymade House' selling all types of fancy garments and
                  School Uniforms fabric in Rajkot, Gujarat
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">1991</p>
                <p className="timeline_step_head">Expanded</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                {" "}
                <p className="timeline_text">
                  Tried and Tested various business models. Stopped retailing of
                  the fancy garments and started selling readymade School
                  uniforms along with setting up in house manufacturing facility
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">1999</p>
                <p className="timeline_step_head">Expanded</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Expanded the retail store to 1800 Sq. Ft store with a capacity
                  to serve 25 customers at a time
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">2009</p>
                <p className="timeline_step_head">Expanded</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Expanded and opened 2nd retail showroom of 4500 Sq. ft and a
                  facility to cater 60 customers at a time. First exclusive
                  school uniform store to have second branch for school uniforms
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">2016</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Entered into a completely digital method for smooth store
                  management and operations
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">2018</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Developed an E-commerce app for all the parents to shop online
                  and developed necessary infrastructure
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">2022</p>
                <p className="timeline_step_head">Digitalization</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Expansion of the same business in Bangalore under the name of
                  The Alchemy Drip.
                </p>
              </div>
            </div>

            <div className="timeline_flex_part2_inner_resp">
              <div className="timeline_inner_since_flex timeline_inner_since_flex_align_start timeline_inner_since_flex_align_start_resp">
                <p className="timeline_since">2023</p>
                <p className="timeline_step_head">Growth</p>
              </div>

              <div className="timeline_third_inner timeline_third_inner_resp">
                <p className="timeline_text">
                  Expanding the chain of retail outlets by adding 3rd showroom
                  in Rajkot of 6000 Sq ft having the capacity to serve 90+
                  customers at a time. Expansion of The Alchemy Drip, with entry
                  in retail business
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimeLine;
